module.exports = __webpack_public_path__ + "img/SER-B-1-IV.25286a03.png";